export default class StatusType {
  static SENT = new StatusType(0, 'demarcate.status.sent')

  static INCLUDED = new StatusType(1, 'demarcate.status.included')

  static WAITING_APPROVAL = new StatusType(
    2,
    'demarcate.status.waiting.approval'
  )

  static APPROVED = new StatusType(3, 'demarcate.status.approved')

  static REJECTED = new StatusType(4, 'demarcate.status.rejected')

  static WAITING_BILLING = new StatusType(5, 'demarcate.status.waiting.billing')

  static BILLED = new StatusType(6, 'demarcate.status.billed')

  static AUTH_FAILED = new StatusType(7, 'demarcate.status.auth.failed')

  static APPROVE_FAIL = new StatusType(8, 'demarcate.status.approveFail')

  static BILLING_FAIL = new StatusType(9, 'demarcate.status.billingFail')

  static allStatus() {
    return [
      StatusType.SENT,
      StatusType.INCLUDED,
      StatusType.WAITING_APPROVAL,
      StatusType.APPROVED,
      StatusType.REJECTED,
      StatusType.WAITING_BILLING,
      StatusType.BILLED,
      StatusType.AUTH_FAILED,
      StatusType.APPROVE_FAIL,
      StatusType.BILLING_FAIL,
    ]
  }

  constructor(value, label) {
    this.value = value
    this.label = label
  }
}
